import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { selectAllGroups } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import classNames from 'classnames';
import { selectHasFotofunBorder } from '../../_redux-borders';
import { selectIsAnyGroupNotEmpty } from '../../_redux-groups';
import { ChangeVariantWindow } from '../change-variant-window/ChangeVariantWindow';
import { FotofunBanner } from './FotofunBanner';
import { PhotoPrintsGroup } from './photo-prints-group/PhotoPrintsGroup';
import styles from './PhotoPrintGroupsGrid.module.scss';

const _PhotoPrintGroupsGrid = forwardRef<HTMLDivElement, Props>(({
    groups, isAnyGroupNotEmpty, hasFotofunBorder
}, ref) => {

    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);

    const groupClassName = classNames(styles.group, {
        [styles.onlyGroup]: groups.length === 1
    });

    return (
        <div ref={ref} className={groups.length < 2 ? styles.dropAreaWrapper : ""}>
            <div className={styles.groups}>
                {groups.map(g => (
                    <PhotoPrintsGroup
                        key={g.id} groupId={g.id}
                        className={groupClassName} />
                ))}

                {isAnyGroupNotEmpty && (
                    <div className={styles.addGroupContainer}>
                        <div className={styles.addGroup}
                             onClick={() => setOpen(true)}>
                            <p className={styles.addGroupMain}>
                                <Icon type='alert-circle-plus' strokeWidth={1.5} className={styles.plusIcon} />
                                {t('photo_prints.extra_group')}
                            </p>
                            <p className={styles.addGroupSub}>{t('photo_prints.different_variant')}</p>
                        </div>
                    </div>
                )}

                {isOpen && (
                    <WindowStackItem>
                        <ChangeVariantWindow
                            title='photo_prints.extra_group'
                            close={() => setOpen(false)} />
                    </WindowStackItem>
                )}
            </div>

            {groups.length < 2 && hasFotofunBorder && (
                <FotofunBanner />
            )}

        </div>
    );
});

type Props = {
    groups: PhotoPrintsJson.Group[];
    isAnyGroupNotEmpty: boolean;
    hasFotofunBorder: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState) => ({
    groups: selectAllGroups(state),
    isAnyGroupNotEmpty: selectIsAnyGroupNotEmpty(state),
    hasFotofunBorder: selectHasFotofunBorder(state)
});

export const PhotoPrintGroupsGrid = connect(
    mapStateToProps,
    null,
    null,
    { forwardRef: true }
)(_PhotoPrintGroupsGrid);